import { AfterViewInit, Directive, ElementRef, EventEmitter, OnDestroy, Output } from '@angular/core';
import { fromEvent, Unsubscribable } from 'rxjs';
import { animateDebounce } from '../_service/animateDebounce';

@Directive({
  selector: '[scrollEvent]'
})
export class ScrolleventDirective implements AfterViewInit, OnDestroy {

  @Output() onScrollEnd = new EventEmitter<any>();
  @Output() onScrollStart = new EventEmitter<any>();
  @Output() onScrollUp = new EventEmitter<any>();

  private offset = 15;
  private interval = 20;
  private onScrollEndTimeout = null;
  private _subscriptions: Array<Unsubscribable> = [];
  constructor(
    private element: ElementRef
  ) {

  }

  ngAfterViewInit(): void {
    //console.log("ScrolleventDirective init",this.element.nativeElement)
    this._subscriptions.push(
      fromEvent(this.element.nativeElement, "scroll").subscribe(event=>this.onContainreScroll(event))
      );
        
  }

  private lastPos = 0;
  onContainreScroll(event) {
    // visible height + pixel scrolled >= total height 
    const target = this.element.nativeElement;
    let scrollUp = false;
    if (this.lastPos > 0 && target.scrollTop < this.lastPos) {
      this.onScrollUp.emit(true);
      scrollUp = true;
      // console.log("scroll up")
    }


    if (this.lastPos > 0 && target.scrollTop == 0) {
      this.onScrollStart.emit(true);
     // console.log("scroll start");
    }

    this.lastPos = target.scrollTop;
    if (!scrollUp && Math.abs( target.offsetHeight + target.scrollTop  - target.scrollHeight) <= this.offset ) {
      clearTimeout(this.onScrollEndTimeout);
      this.onScrollEndTimeout = setTimeout(()=>{
        this.onScrollEnd.emit(true);
      },this.interval);
      //console.log("scroll End");
    }
    //console.log(target.offsetHeight , target.scrollTop, target.scrollHeight)

  }

  ngOnDestroy(): void {
    this._subscriptions.forEach(p => p.unsubscribe());
  }

}
